var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "embed-editor" }, [
    _c("h3", [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.content,
          expression: "content"
        }
      ],
      ref: "content",
      staticClass: "embed-editor__textarea",
      attrs: { placeholder: "埋め込みコードを入力してください" },
      domProps: { value: _vm.content },
      on: {
        blur: _vm.emitInputText,
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.content = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "embed-editor__buttons" }, [
      _c("button", { staticClass: "button large", on: { click: _vm.submit } }, [
        _vm._v(_vm._s(_vm.submitLabel))
      ])
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "embed-editor__close close-button",
        on: { click: _vm.close }
      },
      [_vm._v("×")]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "notice" }, [
      _c("li", [_vm._v("ここに記述したHTMLを、そのまま記事に埋め込みます。")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "HTML・CSSのテクニカルサポートは行っておりません。予めご了承ください。"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }